import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { JobStatus } from 'src/app/actions/job-status.actions';
import { JoblockService } from 'src/app/core/joblock.service';
import { LoggerService } from 'src/app/core/logger.service';
import { UserService } from 'src/app/core/user.service';
import { FeedbackService } from 'src/app/notifications/feedback.service';
import { State } from 'src/app/reducers';
import { BlendEvent, ErrCode, SHARE_DETAILS_OPEN_STATE } from 'src/app/shared/models';
import { BroadcastService } from 'src/app/shared/services/broadcast.service';
import { ShareService } from 'src/app/shared/services/share.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { IErrorCode, IFile, IShareData } from 'src/sync';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { BlendService } from 'src/app/shared/services/blend.service';

@Component({
  selector: 'app-share-delete',
  templateUrl: './share-delete.component.html',
  styleUrls: ['./share-delete.component.scss']
})
export class ShareDeleteComponent implements OnInit, OnDestroy {

  @Input() public openState: number;
  @Input() public shareData: IShareData;
  public selectedPurge = '0'; // default true
  public spinner = false;
  public errors: IErrorCode[] = [];
  public bg = 0;
  public jobSubscription: any;
  public isJobComplete = false;
  public stopShareJob: any;
  public name: string = '';
  public isSmallScreen: boolean = false;
  @Input() showDialog!: boolean;
  options = [];
  @Output() showDialogChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() openStateChange: EventEmitter<number> = new EventEmitter();

  private breakpointSubscription: Subscription;
  constructor(
    private feedbackService: FeedbackService,
    private shareService: ShareService,
    private broadcastService: BroadcastService,
    private JobLockService: JoblockService,
    public breakpointObserver: BreakpointObserver,
    private loggerService: LoggerService,
    private store: Store<State>,
    private snackbarService: SnackbarService,
    private blendService: BlendService
  ) { }

  ngOnInit() {
    this.breakpointSubscription = this.breakpointObserver.observe([
      '(max-width: 599px)',
    ])
    .subscribe((state: BreakpointState) => {
      if (state.breakpoints['(max-width: 599px)']) {
        this.isSmallScreen = true;
      } else {
        this.isSmallScreen = false;
      }
      
    });  

    this.showDialog = true;
    this.initCommentOptions()
    this.name = this.shareData['name']
  }

  ngOnDestroy(): void {
    if (this.breakpointSubscription) {
      this.breakpointSubscription.unsubscribe();
    }
  }

  public postStopShareAction = async () => {

    if (this.stopShareJob.bg == 1) {
      const response = await this.JobLockService.pollJobStatus();
    }

    this.loggerService.info({ isJobComplete: this.isJobComplete });
    this.broadcastService.broadcast('event:file-list.reload');
    this.broadcastService.broadcast('event:share-list.reload');
    this.spinner = false;
    this.feedbackService.setFeedback(
      'success',
      `The share ${this.shareData.name} has been stopped`,
      2000
    );
    this.snackbarService.showMessage('success', 'Folder successfully unshared.')
    this.blendService.track(BlendEvent.DISABLE_SHARE);
    this.closeDialog();
  }

  public stopShare = async () => {
    try {
      this.spinner = true;
      this.errors = [];
      this.stopShareJob = await this.shareService.stopShare(
        this.shareData.shareId,
        this.shareData.sharememberId,
        this.selectedPurge == '0'
      );
      this.postStopShareAction();
    } catch (err) {
      this.snackbarService.showMessage('critical', 'Couldn’t complete action. Try again.');
      this.spinner = false;
      this.errors.push(err);
    }
  }
  private openPopup(state: number) {
    this.openStateChange.next(state);

  }
  closeDialog = (state: number = SHARE_DETAILS_OPEN_STATE.CLOSE_STATE) => {
    this.showDialog = false;
    setTimeout(() => {
      this.showDialogChange.next(false);
      this.openPopup(state)
    }, 50);
  }

  selectedChange = (event: any) => {
    this.selectedPurge = event.value;
  }
  initCommentOptions = () => {
    this.options = [
      {
        label: "No, remove this folder and its contents the next time users sync their devices",
        value: "0",
        disabled: false,
        isChecked: this.selectedPurge == '0'
      },
      {
        label: "Yes, allow users to keep a copy of this folder and its contents",
        value: "1",
        disabled: false,
        isChecked: this.selectedPurge == '1',
      },
    ];
  }
}
